import { TYPE_STRING } from './input-types';

export const id = 'warehouse';
export const apiKey = 'WarehouseLocation';
export const type = TYPE_STRING;

export const warehouse = {
  id,
  apiKey,
  type,
};
